import { postApi } from "./api_instance";

export const applyCouponCode = async (formData, dispatch) => {
  try {
    return await postApi({
      apiUrl: "/projects/api/coupon/getDiscountedAmount",
      dispatch,
      data: formData,
      sendToken: true
    });
  } catch (error) {
    throw error;
  }
};
